/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCatalogRequest
 */
export interface CreateCatalogRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCatalogRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCatalogRequest
     */
    name: string;
}

/**
 * Check if a given object implements the CreateCatalogRequest interface.
 */
export function instanceOfCreateCatalogRequest(value: object): value is CreateCatalogRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateCatalogRequestFromJSON(json: any): CreateCatalogRequest {
    return CreateCatalogRequestFromJSONTyped(json, false);
}

export function CreateCatalogRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCatalogRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CreateCatalogRequestToJSON(json: any): CreateCatalogRequest {
    return CreateCatalogRequestToJSONTyped(json, false);
}

export function CreateCatalogRequestToJSONTyped(value?: CreateCatalogRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

